<template>
  <div
    class="py-2"
  >
    <v-row class="pl-5 mt-n3 font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
      <v-col>
        Branches
        <span v-if="statusFilter">
          <setup-companies-branches-dialog-create
            v-if="$hasPermissionTo(['create branches'])"
            :company-id="company.id"
            @created="loadBranches(company.id)"
          />
        </span>
      </v-col>
    </v-row>
    <v-row class="mb-n10 font-calibri">
      <v-col>
        <v-data-table
          :items="branches"
          :headers="branchHeaders"
          hide-default-footer
          dense
          class="mt-2"
          :loading="branchLoading"
        >
          <template v-slot:item.branch_name="{ item }">
            <div>
              <span>{{ item.branch_name? item.branch_name:'-' }}</span>
            </div>
          </template>

          <template v-slot:item.branch_contact_no="{ item }">
            <div>
              <span>{{ item.branch_contact_no? item.branch_contact_no:'-' }}</span>
            </div>
          </template>

          <template v-slot:item.address="{ item }">
            <div>
              <span>{{ constructAddress(item) ? constructAddress(item):'-' }}</span>
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <setup-companies-branches-dialog-edit
              v-if="$hasPermissionTo(['update branches']) && !company.deleted_at"
              :branch="item"
              @updated="loadBranches(item.company_uid)"
            />
               
            <setup-companies-branches-dialog-delete
              v-if="$hasPermissionTo(['delete branches']) && !company.deleted_at"
              :branch="item"
              @deleted="loadBranches(item.company_uid)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {  
    components: {
      SetupCompaniesBranchesDialogCreate: () => import('@/components/hris/setup/companies/branches/DialogCreate'),
      SetupCompaniesBranchesDialogEdit: () => import('@/components/hris/setup/companies/branches/DialogEdit'),
      SetupCompaniesBranchesDialogDelete: () => import('@/components/hris/setup/companies/branches/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Companies',
      }
    },
    props: {
      company: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        companies: [],
        search: '',
        loading: false,
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        trashedCompanies: [],
        branchHeaders: [
          {
            text: 'Branch Name',
            align: 'left',
            value: 'branch_name',
          },
          {
            sortable: false,
            text: 'Contact No',
            align: 'left',
            value: 'branch_contact_no',
          },
          {
            sortable: false,
            text: 'Address',
            align: 'left',
            value: 'address',
          },
          {
            sortable: false,
            text: '',
            align: 'center',
            value: 'action',
          },
        ],
        branchLoading: false,
        branches: [],
        panel: [0],
      }
    },

    watch: {
      company: function (value) {
        if (!value) return
        this.refreshData()
      },
    },

    created () {
      this.refreshData()
    },
    methods: {
      refreshData () {
        this.loadBranches(this.company.id)
      },

      loadBranches (companyId) {
        this.branchLoading = true

        this.$api.hrisCompanyBranches().list(companyId)
          .then(res => {
            this.branches = _.orderBy(res.data, ['name'], ['asc'])

            this.branchLoading = false
          })
      },

      constructAddress (item) {
        return (item.address_line_one ? item.address_line_one + ',' : '') + (item.address_line_two ? item.address_line_two + ',' : '') + 
          (item.address_line_three ? item.address_line_three + ',' : '') + (item.postcode ? item.postcode + ',' : '') +
          (item.city ? (item.city || {}).name + ', ' : '') + (item.city ? ((item.city || {}).state || {}).name + ', ' : '') +
          (item.city ? (((item.city || {}).state || {}).country || {}).name : '')
      },
    },
  }
</script>

<style scoped>
.selected{
  background-color: rgba(0, 0, 0, .05);
}

.remove-bottom-border {
    border-bottom: 0px !important
}

.border-bottom {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.accordion-max-height{
  max-height: 36px !important;
}
</style>
